import React from 'react';
import {Dates, Time} from '../utils';

const fullScaleChoices = [
  Dates.DAY,
  Dates.LAST_24_HOURS,
  Dates.WEEK,
  Dates.LAST_7_DAYS,
  Dates.MONTH,
  Dates.LAST_30_DAYS,
  Dates.YEAR,
] as Time.Scale[];

// The choices are a function of the argument and nothing else, so there is no
// state to synchronise: the memo drops the second render pass a `chartView` of
// false used to cost on mount, and keeps the filtered array from being rebuilt
// on every render. (The list cannot be a module constant -- suites that mock
// `../utils/Dates` leave `LAST_SCALE_CHOICES` undefined at import time.)
const useScaleChoices = (chartView: boolean = true) =>
  React.useMemo(
    () =>
      chartView
        ? fullScaleChoices
        : // A calendar cannot draw a rolling window, so LAST_* is chart-only.
          fullScaleChoices.filter((s) => !Dates.LAST_SCALE_CHOICES.includes(s)),
    [chartView],
  );

export default useScaleChoices;
